import { get, post, postJson, form, put, delete1 } from '../utils/httpUtils';
import { message } from 'antd';
import { dispatch } from '../App';

const defaultPageSize = 10;
const domain = 'api.jinchim.com';
// const domain = 'localhost';
const apiBaseUrl = 'http://' + domain;


const api = {
    login: {
        url: apiBaseUrl + '/user/login',
        params: function (username, password) {
            return { username, password };
        }
    },
    getRSAPublicKey: {
        url: apiBaseUrl + '/user/getRSAPublicKey'
    },
    listPlatform: {
        url: apiBaseUrl + '/platform/listPlatform',
        params: function (search, pageNumber, pageSize) {
            return { search, pageNumber, pageSize }
        }
    },
    getPlatform: {
        url: apiBaseUrl + '/platform/getPlatform',
        params: function (id) {
            return { id };
        }
    },
    addPlatform: {
        url: apiBaseUrl + '/platform/addPlatform',
        params: function (name, url) {
            return { name, url }
        }
    },
    updatePlatform: {
        url: apiBaseUrl + '/platform/updatePlatform',
        params: function (id, name, url) {
            return { id, name, url }
        }
    },
    deletePlatform: {
        url: apiBaseUrl + '/platform/deletePlatform',
        params: function (id) {
            return { id }
        }
    },
    listPlatformAccount: {
        url: apiBaseUrl + '/platform/listPlatformAccount',
        params: function (search, pageNumber, pageSize) {
            return { search, pageNumber, pageSize }
        }
    },
    getPlatformAccount: {
        url: apiBaseUrl + '/platform/getPlatformAccount',
        params: function (id) {
            return { id }
        }
    },
    getPlatformAccountPassword: {
        url: apiBaseUrl + '/platform/getPlatformAccountPassword',
        params: function (id) {
            return { id }
        }
    },
    addPlatformAccount: {
        url: apiBaseUrl + '/platform/addPlatformAccount',
        params: function (platformId, username, password, tag) {
            return { platformId, username, password, tag }
        }
    },
    updatePlatformAccount: {
        url: apiBaseUrl + '/platform/updatePlatformAccount',
        params: function (id, password, tag) {
            return { id, password, tag }
        }
    },
    deletePlatformAccount: {
        url: apiBaseUrl + '/platform/deletePlatformAccount',
        params: function (id) {
            return { id }
        }
    },
    downloadPlatformAccount: {
        url: apiBaseUrl + '/platform/downloadPlatformAccount'
    },
    listHuobi: {
        url: apiBaseUrl + '/huobi/listHuobi'
    },
    listHuobiInvestment: {
        url: apiBaseUrl + '/huobi/listHuobiInvestment',
        params: function (symbol, pageNumber, pageSize) {
            return { symbol, pageNumber, pageSize }
        }
    },
    listHuobiInvestmentSymbol: {
        url: apiBaseUrl + '/huobi/listHuobiInvestmentSymbol'
    },
    listHuobiInvestmentProfitLoss: {
        url: apiBaseUrl + '/huobi/listHuobiInvestmentProfitLoss',
        params: function (symbol) {
            return { symbol }
        }
    },
    getHuobiInvestment: {
        url: apiBaseUrl + '/huobi/getHuobiInvestment',
        params: function (id) {
            return { id }
        }
    },
    addHuobiInvestment: {
        url: apiBaseUrl + '/huobi/addHuobiInvestment',
        params: function (symbol, type, price, volume, commission, totalPrice) {
            return { symbol, type, price, volume, commission, totalPrice }
        }
    },
    updateHuobiInvestment: {
        url: apiBaseUrl + '/huobi/updateHuobiInvestment',
        params: function (id, price, volume, commission, totalPrice) {
            return { id, price, volume, commission, totalPrice }
        }
    },
    deleteHuobiInvestment: {
        url: apiBaseUrl + '/huobi/deleteHuobiInvestment',
        params: function (id) {
            return { id }
        }
    },
    listQuantRobot: {
        url: apiBaseUrl + '/quant/listQuantRobot',
        params: function (pageNumber, pageSize) {
            return { pageNumber, pageSize }
        }
    },
    listQuantRobotStrategy: {
        url: apiBaseUrl + '/quant/listQuantRobotStrategy'
    },
    listQuantRobotLog: {
        url: apiBaseUrl + '/quant/listQuantRobotLog',
        params: function (robotId, type, pageNumber, pageSize) {
            return { robotId, type, pageNumber, pageSize }
        }
    },
    getQuantRobot: {
        url: apiBaseUrl + '/quant/getQuantRobot',
        params: function (id) {
            return { id }
        }
    },
    addQuantRobot: {
        url: apiBaseUrl + '/quant/addQuantRobot',
        params: function (name, strategy) {
            return { name, strategy }
        }
    },
    updateQuantRobot: {
        url: apiBaseUrl + '/quant/updateQuantRobot',
        params: function (id, strategyData) {
            return { id, strategyData }
        }
    },
    deleteQuantRobot: {
        url: apiBaseUrl + '/quant/deleteQuantRobot',
        params: function (id) {
            return { id }
        }
    },
    startRobot: {
        url: apiBaseUrl + '/quant/startRobot',
        params: function (robotId) {
            return { robotId }
        }
    },
    stopRobot: {
        url: apiBaseUrl + '/quant/stopRobot',
        params: function (robotId) {
            return { robotId }
        }
    },
    sendCommand: {
        url: apiBaseUrl + '/quant/sendCommand',
        params: function (robotId, command) {
            return { robotId, command }
        }
    },
    loginDing: {
        url: apiBaseUrl + '/ding/loginDing',
        params: function (url, sessionId) {
            return { url, sessionId }
        }
    },
    getAppToken: {
        url: apiBaseUrl + '/ding/getAppToken',
        params: function (sessionId) {
            return { sessionId }
        }
    },
    listEat: {
        url: apiBaseUrl + '/eat/listEat'
    }
}

function onGet(url, data) {
    let queryString = '?';
    for (let key in data) {
        if (data[key] === null || data[key] === '' || data[key] === undefined) {
            continue
        }
        queryString += key + '=' + data[key] + '&';
    }
    return get(url + queryString, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else if (response.msg === '未登录') {
            dispatch.common.isLogin(false);
        } else {
            message.error(response.msg);
        }
    }).catch(() => {
        message.error('网络通讯失败');
    });
}

function onPost(url, data) {
    let queryString = '';
    for (let key in data) {
        if (data[key] === null || data[key] === '' || data[key] === undefined) {
            continue
        }
        queryString += key + '=' + data[key] + '&';
    }
    return post(url, queryString, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else if (response.msg === '未登录') {
            dispatch.common.isLogin(false);
        } else {
            message.error(response.msg);
        }
    }).catch(() => {
        message.error('网络通讯失败');
    });
}

function onPostJson(url, data) {
    return postJson(url, data, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else if (response.msg === '未登录') {
            dispatch.common.isLogin(false);
        } else {
            message.error(response.msg);
        }
    }).catch(() => {
        message.error('网络通讯失败');
    });
}

function onForm(url, formData, callback) {
    return form(url, formData, localStorage.getItem('token'), callback).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(() => {
        message.error('网络通讯失败');
    });
}

function onPut(url, data) {
    return put(url, data, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(() => {
        message.error('网络通讯失败');
    });
}

function onDelete(url, data) {
    return delete1(url, data, localStorage.getItem('token')).then(response => {
        if (response.state === 'ok') {
            return response.data;
        } else {
            message.error(response.msg);
        }
    }).catch(() => {
        message.error('网络通讯失败');
    });
}

export {
    defaultPageSize,
    domain,
    api,
    onGet,
    onPost,
    onPostJson,
    onForm,
    onPut,
    onDelete
}


// WEBPACK FOOTER //
// ./src/core/api3.js